
export default function Hero() {
  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://storage.readdy-site.link/project_files/9d642ecb-4e9a-4749-b8c5-539da4657e0f/058ed1d3-b34c-4285-9a72-e9631e76cacb_WhatsApp-Image-2026-03-20-at-12.31.51.jpeg?v=5da93fe1fd21a841b1452259b32b41f4"
          alt="Table Tennis Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
        <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 drop-shadow-lg">
          Greater Bay Table Tennis Association
        </p>
        
        <p className="text-xl md:text-2xl text-white/95 mb-12 max-w-3xl mx-auto leading-relaxed drop-shadow-lg font-medium">
          致力於推廣乒乓球運動，加強各球會友賽活動<br />促進大灣區體育交流與發展
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#events"
            className="px-10 py-4 bg-emerald-600 hover:bg-emerald-700 text-white text-lg font-bold rounded-full transition-all shadow-2xl hover:shadow-emerald-500/50 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-trophy-line mr-2"></i>
            查看賽事
          </a>
          <a
            href="#video"
            className="px-10 py-4 bg-white/95 hover:bg-white text-gray-900 text-lg font-bold rounded-full transition-all shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-youtube-fill mr-2 text-red-600"></i>
            觀看影片
          </a>
          <a
            href="tel:+85265003988"
            className="px-10 py-4 bg-transparent border-2 border-white hover:bg-white hover:text-gray-900 text-white text-lg font-bold rounded-full transition-all shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line mr-2"></i>
            立即聯絡
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center animate-bounce">
          <span className="text-white text-sm mb-2 font-medium">向下滾動</span>
          <i className="ri-arrow-down-line text-white text-2xl"></i>
        </div>
      </div>
    </section>
  );
}